import mainScript from './components/main/script'
import { popUpScript } from './components/popup/script'
import { showForm } from './components/popup/script'
const EventEmitter = require('events')
const loadScriptFormEvent = new EventEmitter()

loadScriptFormEvent.on('loadScriptForm', () => popUpScript())
const showFormEvent = new EventEmitter()
showFormEvent.on('showForm', () => showForm())
const events = {
    loadScriptFormEvent,
    showFormEvent
}
mainScript(events)


if( window.localStorage.getItem('cache') === 'cached') {
    window.location.replace('https://slotoking.ua')
}

document.querySelector("#registerBtn").addEventListener('click', ()=> {
    document.querySelector("#registerBtn").classList.toggle('loader')
    popUpScript()
    setTimeout(()=>{
       showForm()
    }, 2000)

    dataLayer.push ({
        'event':'click_button',
        'button_name':'cta_1',
        'location':''
    })
})

let loginBtn = document.querySelector('.loginBtn');
loginBtn.addEventListener('click', (e) => {
    e.preventDefault();
    dataLayer.push ({
        'event':'click_button',
        'button_name':'login',
        'location':''
    })

    // window.location.replace('https://slotoking.ua/?login=true')
})

document.querySelector('#RegisterForm').addEventListener('submit', () => {
    const type = document.querySelector(`[data-value='phone']`).classList.contains('active') ? 'phone' : 'email';

    dataLayer.push ({
        'event':'registration',
        'step':'success',
        type,
        'location':'header'
    })
})